<template>
	<div class="sinfo_list">
		<div class="content_list" v-for="(item,index) in infoList" :key="index" @click="showDetail(item)">
			<p class="content_list_firstp">·</p>
			<p class="content_list_lastp2">{{item.title}}</p>
			<div class="innerDownload">
				<span>{{item.created_at}}</span>
				<p @click="showDetail(item)">下载</p>
			</div>
		</div>
		<div style="text-align: center;margin: 20px 0;">
			<el-pagination :hide-on-single-page="true" @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="page_size"
				:layout="layout" :total="totalNum">
			</el-pagination>
		</div>
		
	</div>
</template>

<script>
	import download from "downloadjs";
	
	import {
		getFileDownload
	} from '../../../api/moudles/home.js'
	export default {
		data() {
			return {
				infoList: [],
				currentPage:1,
				totalNum:0,
				columnCode:'',
				layout: "total, sizes, prev, pager, next, jumper",
			}
		},
		props: {
			orgin: {
				type: String,
				default: ''
			},
			column_code: {
				type: String,
				default: ''
			},
			page_size: {
				type: Number,
				default: 10
			}
		},
		watch: {
			column_code(newValue) {
				this.columnCode = newValue
				this.getFileDownload(newValue,1 ,this.page_size)
			}
		},
		created() {
			const screenWidth = window.screen.width;
			if (screenWidth < 760) {
				this.layout = "prev, pager, next"
			}
			if (screenWidth > 760) {
				this.layout = "total, sizes, prev, pager, next, jumper"
			}
		},
		methods: {
			handleSizeChange(val){
				this.page_size = val
			},
			handleCurrentChange(val){
				this.currentPage = val
				this.getFileDownload(this.columnCode,val,this.page_size)
			},
			showDetail(item) {
				download(item.file_path)
			},
			// 获取下载
			async getFileDownload(column_code,pageNo, pageSize) {
				await getFileDownload({
					data: {
						column_code,
						pageNo,
						pageSize,
					},
					success: (res) => {
						this.infoList = res.data
						this.totalNum = parseInt(res.total)
					}
				})
			},
		}
	}
</script>

<style>
	.innerDownload{
		display: flex;
	}
	.innerDownload p{
		width: 50px;
		text-align: center;
		margin-left: 10px;
		color: #D40D16;
		font-size: 14px;
	}
	.sinfo_list {
		/* width: 506px; */
	}

	.sinfo_list_head {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.sinfo_list_head p {
		font-family: PingFangSC-Semibold;
		font-size: 20px;
		color: #131415;
		letter-spacing: 0;
		font-weight: 600;
	}

	.big_title_box {
		min-width: 100px;
		display: flex;
		height: 40px;
		line-height: 40px;
		padding-right: 10px;
	}

	.big_title_p {
		min-width: 100px;
		font-family: PingFangSC-Semibold;
		font-size: 24px;
		color: #131415;
		letter-spacing: 0;
		text-align: center;
		font-weight: 600;
		margin-left: 15px;
	}

	/* 咨询列表-可复用 */
	.content_list {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 10px 0 20px;
		border-bottom: 2px dotted #f5f5f5;
	}

	.content_list p:hover {
		color: #015AAA;
		text-decoration: underline;
		cursor: pointer;
	}

	.content_list_firstp {
		font-size: 35px;
	}

	.content_list_lastp2 {
		font-family: PingFangSC-Regular;
		font-size: 15px;
		color: #000000;
		letter-spacing: 0;
		text-align: left;
		line-height: 24px;
		font-weight: 400;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: calc(100% - 160px);
	}

	.content_list span {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #000000;
		letter-spacing: 0;
		text-align: left;
		line-height: 24px;
		font-weight: 400;
	}

	.sinfo_list_head_span {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #D40D16;
		letter-spacing: 0;
		text-align: center;
		line-height: 40px;
		font-weight: 400;
	}

	.sinfo_list_head_span:hover {
		cursor: pointer;
		text-decoration: underline;
	}
</style>
